import { connect } from 'react-redux';

import {
  getIsAppBannerEnabled,
  getIsHomepage,
  getIsMobile,
  getIsWebview,
  getIsWhitelabel,
} from 'src/store/view/selectors';
import { BannerController } from './BannerController';

const mapStateToProps = (state) => ({
  isMobile: getIsMobile(state),
  isHomepage: getIsHomepage(state),
  isWhiteLabel: getIsWhitelabel(state),
  isWebview: getIsWebview(state),
  isAppBannerEnabled: getIsAppBannerEnabled(state),
});

const connector = connect(mapStateToProps);

export default connector(BannerController);
